import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {
  isActive?: boolean;
}

export const IconComments: React.FC<Props> = ({ isActive }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <path
        d="M10.6701 1.22951H9.79651C9.47962 1.22951 9.22274 0.972622 9.22274 0.655738C9.22274 0.295082 8.9198 0 8.54955 0C8.17929 0 7.87635 0.295082 7.87635 0.655738C7.87635 0.972622 7.61947 1.22951 7.30258 1.22951H4.7139C4.39702 1.22951 4.14013 0.972622 4.14013 0.655738C4.14013 0.295082 3.8372 0 3.46694 0C3.09669 0 2.79375 0.295082 2.79375 0.655738C2.79375 0.972622 2.53686 1.22951 2.21998 1.22951H1.34639C0.605873 1.22951 0 1.81967 0 2.54098V11.6885C0 12.4098 0.605873 13 1.34639 13H10.6533C11.3938 13 11.9997 12.4098 11.9997 11.6885V2.54098C12.0165 1.81967 11.4106 1.22951 10.6701 1.22951ZM10.6533 9.87213C10.6533 10.8662 9.84739 11.6721 8.85327 11.6721H3.14639C2.15227 11.6721 1.34639 10.8662 1.34639 9.87213V7.96393C1.34639 6.96982 2.15227 6.16393 3.14639 6.16393H8.85327C9.84739 6.16393 10.6533 6.96982 10.6533 7.96393V9.87213Z"
        fill={isActive ? colors.gp1 : colors.cflowerBlue}
      />
    </svg>
  );
};
